import * as React from 'react';
import { SVGProps } from 'react';
export const SvgRadio = (props: SVGProps<SVGSVGElement>) => (
  <svg width={34} height={34} fill="currentColor" className="svg" {...props}>
    <circle
      cx={12}
      cy={12}
      r={8}
      fill="none"
      stroke="#C72C3F"
      strokeWidth={2}
      className="radioOutline"
    />
    <circle cx={12} cy={12} r={5} fill="currentColor" className="radioDot" />
  </svg>
);
